// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__SnS8L","disabled":"Checkbox_disabled__xupqX","indeterminate":"Checkbox_indeterminate__ZOimP"};